var exports = {
  "g": "Main__HPSVxN",
};

module.exports = exports;
